<template>
  <v-runtime-template :template="includeTemp"/>
</template>
<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'

export default {
  name: 'CommonModal',
  components: {
    VRuntimeTemplate
  },
  props: {
    linkUrl: {
      type: String,
      default: ''
    },
    templateFile: {
      type: String,
      default: ''
    },
    videoSrc: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      includeHtml: '',
      options: {
        height: '100%',
        color: '#ccc',
        opacity: 1,
        size: '.6rem',
        distance: '1rem',
        disableFadeOut: true,
        alwaysVisible: true
      }
    }
  },
  computed: {
    includeTemp () {
      return this.includeHtml
    },
    commonAlertConfirmAttrs () {
      return {
        ...this.componentAttrs,
        useDefaultHeader: false,
        useDefaultFooter: false,
        fullModal: false,
        mainclass: {
          'alert_type': this.isAlert
        }
      }
    }
  },
  mounted () {
  },
  async created () {
    this.getEmptyTemplate(this.templateFile)
  },
  methods: {
    getEmptyTemplate (resourceUrl, next) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.seventhSubTemplate = res
        this.includeHtml = wepHtmlToString.seventhSubTemplate
      })
    },
    closePopup () {
      this.$emit('close')
    },
    closeYoutube () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_common/wep-popup/WepCommModal.vue